/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetAllQuestConfigsForUserResponseAllOf,
    GetAllQuestConfigsForUserResponseAllOfFromJSON,
    GetAllQuestConfigsForUserResponseAllOfFromJSONTyped,
    GetAllQuestConfigsForUserResponseAllOfToJSON,
    PaginatedResponse,
    PaginatedResponseFromJSON,
    PaginatedResponseFromJSONTyped,
    PaginatedResponseToJSON,
    PaginationInfo,
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    QuestConfig,
    QuestConfigFromJSON,
    QuestConfigFromJSONTyped,
    QuestConfigToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetQuestConfigsResponse
 */
export interface GetQuestConfigsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetQuestConfigsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<QuestConfig>}
     * @memberof GetQuestConfigsResponse
     */
    questConfigs: Array<QuestConfig>;
}

export function GetQuestConfigsResponseFromJSON(json: any): GetQuestConfigsResponse {
    return GetQuestConfigsResponseFromJSONTyped(json, false);
}

export function GetQuestConfigsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQuestConfigsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'questConfigs': ((json['questConfigs'] as Array<any>).map(QuestConfigFromJSON)),
    };
}

export function GetQuestConfigsResponseToJSON(value?: GetQuestConfigsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paginationInfo': PaginationInfoToJSON(value.paginationInfo),
        'questConfigs': ((value.questConfigs as Array<any>).map(QuestConfigToJSON)),
    };
}


